import { useQuery, useQueries } from "@tanstack/react-query";
import axios from "axios";

export const pageSize = 100;

const showsQuery = (accountID, sort, filter) => (pageIndex) => ({
    queryKey: [accountID, "shows", sort, filter, pageIndex],
    queryFn: () =>
        axios.get(`/api/${ accountID }/metrics/shows?pageIndex=${ pageIndex }&pageSize=${ pageSize }&sort=${ sort }&filter=${ filter }`)
            .then(res => res.data)
})

export const useShowsPages = (accountID, sort, filter, pages) => {
    return useQueries({
        queries: pages?.map(showsQuery(accountID, sort, filter))
    });
};

export const useShows = (accountID, sort = "T", filter = "", pageIndex = 0) => {
    return useQuery(showsQuery(accountID, sort, filter)(pageIndex));
};
